import ManageEventRegistrations from "./ManageEventRegistrations";
export default ManageEventRegistrations;
